module.exports = __webpack_public_path__ + "img/plant_3.11643d43.webp";